// Fontawesome
import "font-awesome/fonts/fontawesome-webfont.eot";
import "font-awesome/css/font-awesome.css";
// React
import * as React from "react";
import * as ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
// App
import App from "./App";

import * as EN from "./locales/en/translation.json";
import * as FR from "./locales/fr/translation.json";
import { initReactI18next } from "react-i18next";
import i18n from "i18next";

const resources = {
  en: {
    translation: EN,
  },
  fr: {
    translation: FR,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

ReactDOM.render(
  <HashRouter>
    <App />
  </HashRouter>,
  document.getElementById("root")
);
